import { ContentfulStaticCtaDataLayerObject } from '~/utils/googleTagManager'

export type ContentfulCtaEventProps = {
  sectionId: string
  sectionHeading: string
  linkReference?: string
  contentfulEntryId?: string
  contentfulRevisionId?: number
}

export const CTA_EVENT_NAME = 'ctaEvent'

const processStrings = (str: string) => {
  return str.toLowerCase().replaceAll(/[-_]+/g, ' ').trim()
}

export const generateContentfulCtaGTMEventData = (
  ctaLabel: string,
  {
    sectionId,
    sectionHeading,
    linkReference,
    contentfulEntryId,
    contentfulRevisionId,
  }: ContentfulCtaEventProps
): ContentfulStaticCtaDataLayerObject => {
  const navElement = processStrings(sectionId)
  return {
    nav_element: navElement,
    nav_type: 'click',
    nav_action: `[1] ${processStrings(sectionHeading)} | [2] ${processStrings(
      linkReference ?? ctaLabel
    )}`,
    ...(contentfulEntryId !== undefined && { contentful_entry_id: contentfulEntryId }),
    ...(contentfulRevisionId !== undefined && {
      contentful_revision_id: contentfulRevisionId,
    }),
  }
}
